import type { ReactNode } from "react";
import { toast, type Id, type ToastOptions } from "react-toastify";
import { ToastBody } from "./ToastBody";

export type FeedbackToastOptions = ToastOptions & {
  /** Optional bold first line above the message */
  title?: string;
};

function buildOptions(opts?: FeedbackToastOptions): ToastOptions {
  if (!opts) return { icon: false };
  const { title: _title, ...rest } = opts;
  return { icon: false, ...rest };
}

/**
 * Unified toast API — always use this instead of importing react-toastify
 * directly, so every toast shares the same look (icon badge + light card).
 */
export const showToast = {
  success(message: ReactNode, opts?: FeedbackToastOptions): Id {
    return toast.success(
      <ToastBody variant="success" title={opts?.title} message={message} />,
      buildOptions(opts),
    );
  },
  error(message: ReactNode, opts?: FeedbackToastOptions): Id {
    return toast.error(
      <ToastBody variant="error" title={opts?.title} message={message} />,
      buildOptions(opts),
    );
  },
  warning(message: ReactNode, opts?: FeedbackToastOptions): Id {
    return toast.warning(
      <ToastBody variant="warning" title={opts?.title} message={message} />,
      buildOptions(opts),
    );
  },
  info(message: ReactNode, opts?: FeedbackToastOptions): Id {
    return toast.info(
      <ToastBody variant="info" title={opts?.title} message={message} />,
      buildOptions(opts),
    );
  },
  loading(message: ReactNode, opts?: FeedbackToastOptions): Id {
    return toast.loading(
      <ToastBody variant="loading" title={opts?.title} message={message} />,
      buildOptions(opts),
    );
  },
  dismiss(id?: Id) {
    toast.dismiss(id);
  },
};
